import { getPreviewDefaultActionsData } from '../default/getDefaultChickletHoverActions';
const getCreditMemoChickletHoverActions = args => {
  return {
    PrimaryAction: getPreviewDefaultActionsData(args),
    SecondaryActions: []
  };
};
export default getCreditMemoChickletHoverActions;